import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Target, Compass, FileCheck, Mail, Phone } from 'lucide-react';
import { createCheckout } from '../services/api';
import PreCheckoutModal from '../components/PreCheckoutModal';
import { toast } from 'sonner';

export default function Livret1ASPPage() {
  const [loading, setLoading] = useState(false);
  const [checkoutModal, setCheckoutModal] = useState(false);

  const handleBuy = async () => {
    setCheckoutModal(true);
  };

  const handleConfirm = async ({ nom, prenom, email, telephone }) => {
    setCheckoutModal(false);
    setLoading(true);
    try {
      const data = await createCheckout({
        programId: 'livret-1-asp',
        formula: 'kit',
        kitId: 'livret-1-complet',
        kitTitle: 'Accompagnement complet — Livret 1 (Recevabilité VAE)',
        price: 290,
        origin: window.location.origin,
        email, nom, prenom, telephone
      });
      if (data.url) window.location.href = data.url;
    } catch (e) {
      toast.error("Erreur lors de la création du paiement. Veuillez réessayer.");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-main)', paddingTop: '80px' }}>
      <div className="container" style={{ maxWidth: '950px', margin: '0 auto', padding: '3rem 1.5rem' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem', paddingTop: '1rem' }}>
          <h1 className="heading-1" style={{ marginBottom: '1rem', fontSize: '2rem' }}>
            Accompagnement Livret 1 — Recevabilité VAE
          </h1>
          <p style={{ fontSize: '1.2rem', color: 'var(--text-primary)', maxWidth: '700px', margin: '0 auto 1.25rem', fontWeight: 600 }}>
            Pour les candidats qui souhaitent uniquement de l'aide pour constituer et déposer leur Livret 1.
          </p>
          <p style={{
            display: 'inline-block',
            background: '#ECFDF5', color: '#065F46',
            padding: '0.75rem 1.5rem', borderRadius: '2rem',
            fontWeight: 700, fontSize: '1.05rem'
          }}>
            Le Livret 1 est déjà inclus dans toutes nos formules d'accompagnement (Bronze, Silver, Gold)
          </p>
        </div>

        {/* Info plateformes */}
        <div className="card" style={{
          padding: '1.5rem 2rem', marginBottom: '2rem',
          background: 'linear-gradient(135deg, #FFF7ED 0%, #fff 100%)',
          border: '2px solid #d4af3730'
        }}>
          <h3 style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '0.75rem', color: '#8B6914' }}>
            Où déposer votre Livret 1 ?
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <p className="body-text"><strong style={{ color: '#E75480' }}>Site ASP</strong></p>
            <p className="body-text"><strong style={{ color: '#8B5CF6' }}>DAVA</strong></p>
            <p className="body-text"><strong style={{ color: '#059669' }}>France VAE</strong></p>
          </div>
          <p style={{ marginTop: '0.75rem', fontWeight: 600, color: '#8B6914', fontSize: '0.9rem', fontStyle: 'italic' }}>
            Nous pouvons vous aider pour tous les Livrets 1 ou étude de faisabilité des diplômes que nous accompagnons.
          </p>
        </div>

        {/* Offre principale */}
        <div className="card" style={{
          padding: '2.5rem',
          background: 'linear-gradient(135deg, #fce4ec 0%, #fff 60%)',
          border: '3px solid #E7548040',
          marginBottom: '2rem'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h2 style={{ fontWeight: 800, fontSize: '1.3rem', color: '#E75480', marginBottom: '0.25rem' }}>
              Accompagnement complet — Livret 1
            </h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
              Un accompagnement structuré et sécurisé
            </p>
          </div>

          {/* 3 sections APDR */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>

            {/* Objectif */}
            <div style={{ background: 'white', borderRadius: '1rem', padding: '1.5rem', border: '1px solid #f0e0e5' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                <Target size={20} color="#E75480" />
                <h3 style={{ fontWeight: 700, fontSize: '1rem', color: '#E75480', margin: 0 }}>Objectif</h3>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {[
                  'Présentation de la démarche VAE',
                  'Clarification de votre projet et du diplôme visé',
                  'Création et paramétrage de votre compte sur la plateforme (accompagnement pas à pas)'
                ].map((item, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <CheckCircle size={16} style={{ flexShrink: 0, color: '#E75480', marginTop: '2px' }} />
                    <span style={{ fontSize: '0.85rem', lineHeight: '1.35' }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Positionnement */}
            <div style={{ background: 'white', borderRadius: '1rem', padding: '1.5rem', border: '1px solid #f0e0e5' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                <Compass size={20} color="#8B5CF6" />
                <h3 style={{ fontWeight: 700, fontSize: '1rem', color: '#8B5CF6', margin: 0 }}>Positionnement</h3>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {[
                  'Vérification du nombre d\'heures travaillées',
                  'Analyse de votre parcours professionnel',
                  'Étude de votre expérience au regard du référentiel du diplôme visé'
                ].map((item, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <CheckCircle size={16} style={{ flexShrink: 0, color: '#8B5CF6', marginTop: '2px' }} />
                    <span style={{ fontSize: '0.85rem', lineHeight: '1.35' }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Restitution */}
            <div style={{ background: 'white', borderRadius: '1rem', padding: '1.5rem', border: '1px solid #f0e0e5' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                <FileCheck size={20} color="#059669" />
                <h3 style={{ fontWeight: 700, fontSize: '1rem', color: '#059669', margin: 0 }}>Restitution</h3>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {[
                  'Relecture complète et validation du dossier',
                  'Dépôt du Livret 1 sur la plateforme',
                  'Disponibilité jusqu\'à réception de la notification de recevabilité',
                  'Ajustements si nécessaire'
                ].map((item, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <CheckCircle size={16} style={{ flexShrink: 0, color: '#059669', marginTop: '2px' }} />
                    <span style={{ fontSize: '0.85rem', lineHeight: '1.35' }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Modalités */}
          <div style={{
            display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap',
            marginBottom: '2rem', padding: '1rem', background: '#fdf2f8', borderRadius: '0.75rem'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <CheckCircle size={18} color="#059669" />
              <span style={{ fontWeight: 600, fontSize: '0.9rem' }}>Accompagnement individualisé</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Mail size={18} color="#059669" />
              <Phone size={18} color="#059669" />
              <span style={{ fontWeight: 600, fontSize: '0.9rem' }}>Échanges par mail et téléphone illimités inclus</span>
            </div>
          </div>

          {/* Prix + CTA */}
          <div style={{ textAlign: 'center' }}>
            <p style={{ fontSize: '0.85rem', color: '#6B7280', marginBottom: '0.25rem' }}>Tarif forfaitaire</p>
            <p style={{ fontSize: '2.5rem', fontWeight: 800, color: '#E75480', marginBottom: '0.5rem' }}>
              290€
            </p>
            <p style={{ fontSize: '0.8rem', color: '#6B7280', marginBottom: '1.25rem' }}>
              ou 3x 97€ sans frais
            </p>
            <button
              data-testid="buy-livret1"
              className="btn-primary"
              disabled={loading}
              onClick={handleBuy}
              style={{
                padding: '0.85rem 2.5rem', fontSize: '1rem',
                display: 'inline-flex', alignItems: 'center', gap: '0.5rem'
              }}
            >
              {loading ? 'Chargement...' : (
                <><ArrowRight size={20} /> Commencer mon Livret 1</>
              )}
            </button>
          </div>
        </div>

        {/* Déduction prix */}
        <div className="card" style={{
          padding: '1.25rem 2rem', marginBottom: '2rem', textAlign: 'center',
          background: 'linear-gradient(135deg, #ECFDF5 0%, #fff 100%)',
          border: '2px solid #05966930'
        }}>
          <p style={{ fontWeight: 600, color: '#065F46', fontSize: '0.95rem' }}>
            Si vous prenez par la suite un accompagnement Bronze, Silver ou Gold, le prix du Livret 1 (290€) sera déduit du prix de la formule choisie.
          </p>
        </div>

        {/* Note */}
        <div className="card" style={{ padding: '1.5rem 2rem', textAlign: 'center' }}>
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            Vous souhaitez un accompagnement complet incluant le Livret 1, le Livret 2, les corrections et la préparation à l'oral ?<br />
            <Link to="/programs" style={{ color: '#E75480', fontWeight: 600 }}>Découvrez nos formules Bronze, Silver et Gold</Link> pour chaque diplôme.
          </p>
        </div>

      </div>

      <PreCheckoutModal
        open={checkoutModal}
        onClose={() => setCheckoutModal(false)}
        onConfirm={handleConfirm}
        loading={loading}
      />
    </div>
  );
}
